import { Button, Flex } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Document, Page, pdfjs } from "react-pdf";
import styles from "./index.module.scss";

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;

export const PdfViewer = ({ pdfFile }: { pdfFile: any }) => {
  const { t } = useTranslation();
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageNumber, setPageNumber] = useState<number>(1);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }): void => {
    setNumPages(numPages);
  };

  return (
    <div>
      <Document
        file={pdfFile}
        onLoadSuccess={onDocumentLoadSuccess}
        error={t("pdf_viewer.error")}
      >
        <Page
          className={styles.pdfPage}
          pageNumber={pageNumber}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>

      {numPages && (
        <Flex justify="space-between" align="center" style={{ marginTop: 16 }}>
          <Button
            disabled={pageNumber <= 1}
            onClick={() => setPageNumber(pageNumber - 1)}
          >
            {t("pdf_viewer.back")}
          </Button>
          <span>
            {t("pdf_viewer.page", { current: pageNumber, total: numPages })}
          </span>
          <Button
            disabled={pageNumber >= numPages}
            onClick={() => setPageNumber(pageNumber + 1)}
          >
            {t("pdf_viewer.forward")}
          </Button>
        </Flex>
      )}
    </div>
  );
};
